import React, { useCallback, useState } from 'react';
import { ModalMainBodyStyled, ModalMainStyled } from './modal.styled';
import alarmsStore from '../../../stores/alarms.store';
import AlarmMoreInfo from '../alarmsMoreInfo/AlarmMoreInfo';
import { Modal } from '@fluentui/react';
import { PrimaryButtonStyled } from '../../../style/components/button.styled';
import { addToast } from '../toasts/Toast';
import styled from 'styled-components';

const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 12px;

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
  }
`;

const FooterButtonsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  border-top: 1px solid var(--border-color);
  padding-top: 16px;
`;

const ModalAlarm = ({ data, close }) => {
    const { alarm, text, severity } = data;

    const [isSending, setIsSending] = useState(false);

    const handleSubmit = useCallback(async () => {
        if (isSending) {
            return;
        }

        setIsSending(true);

        const status = alarm.status === 1 ? 2 : 1;
        try {
            await alarmsStore.setAlarmStatus(alarm._id, status);
            addToast(status === 2 ? 'Alarm marked as read' : 'Alarm marked as unread', 'suc');
            close();
        } catch (error) {
            addToast(error.message || 'Failed to update alarm', 'error');
        } finally {
            setIsSending(false);
        }

    }, [isSending, alarm, close]);

    return (
        <ModalMainStyled>
            <Modal
                titleAriaId={ 'titleIdd' }
                isOpen={ true }
                onDismiss={ close }
                isBlocking={ false }
                containerClassName={ 'default-modal' }
            >
                <div className={ 'close-button' } onClick={ close }/>
                <ModalMainBodyStyled style={{ padding: '4px' }}>
                    <HeaderStyled>
                        <h2>Alarm Details</h2>
                    </HeaderStyled>

                    <AlarmMoreInfo
                        alarm={ alarm }
                        severity={ severity }
                        text={ text }
                    />

                    <FooterButtonsStyled>
                        <PrimaryButtonStyled
                            className={ isSending ? 'loader' : '' }
                            onClick={ handleSubmit }
                        >
                            Mark as { alarm.status === 1 ? 'read' : 'unread' }
                        </PrimaryButtonStyled>
                    </FooterButtonsStyled>
                </ModalMainBodyStyled>
            </Modal>
        </ModalMainStyled>
    );
};

export default ModalAlarm;
